import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import styles from './HpRespPromoModulePromoItem.scss';

function HpRespPromoModulePromoItem({ promotion, className, isUnified, onClick }) {
    const { mobileImageUrl, imageUrl, link, alignment } = promotion;

    const itemClassNames = classnames(styles.item, className, {
        [styles.isSplit]: !isUnified,
        [styles.isUnified]: isUnified,
    });

    const imageClassNames = classnames(styles.image, {
        [styles.alignmentCenter]: alignment === 'center',
        [styles.alignmentLeft]: alignment === 'left',
        [styles.alignmentRight]: alignment === 'right',
    });

    const shownImageUrl = imageUrl || mobileImageUrl;

    return (
        <div className={itemClassNames}>
            <a href={link} className={styles.link} onClick={onClick}>
                <img className={imageClassNames} src={shownImageUrl} />
            </a>
        </div>
    );
}

HpRespPromoModulePromoItem.propTypes = {
    promotion: PropTypes.shape({
        imageUrl: PropTypes.string,
        mobileImageUrl: PropTypes.string,
        link: PropTypes.string,
        imageHeight: PropTypes.string,
        alignment: PropTypes.string,
    }).isRequired,
    className: PropTypes.string.isRequired,
    isUnified: PropTypes.bool.isRequired,
    onClick: PropTypes.func,
};

HpRespPromoModulePromoItem.defaultProps = {
    onClick: () => {},
};

export { HpRespPromoModulePromoItem };
